<!-- 404页面 -->
<template>
    <div class="error-page">  
        <h1>404 Not Found</h1>  
        <p>对不起，您请求的页面不存在或已被删除。</p>
    </div>  
</template>

<script setup>

</script>

<style scoped>
.error-page {  
  text-align: center;  
  padding: 50px;  
  background-color: #f4f4f4;  
}  
  
.error-page h1 {  
  color: #333;  
}  
  
.error-page p {  
  color: #666;  
  margin-top: 20px;  
}  
  
.error-page a {  
  color: #007bff;  
  text-decoration: none;  
} 
</style>